<h3>Клиенты</h3>

<p-table [value]="clientList" [paginator]="true" [rows]="10" [showCurrentPageReport]="true"
  [tableStyle]="{'min-width': '50rem'}" currentPageReportTemplate="{first} - {last} из {totalRecords} записей"
  [rowsPerPageOptions]="[10,100,500, 1000]" styleClass="p-datatable-striped" stripedRows>
  <ng-template pTemplate="header">
    <tr>
      <th pSortableColumn="login">
        <div class="col">
          Логин
          <p-columnFilter type="text" field="login" display="menu"></p-columnFilter>
          <p-sortIcon field="login"></p-sortIcon>
        </div>
      </th>
      <th pSortableColumn="client_code">
        <div class="col">
          Код
          <p-columnFilter type="text" field="client_code" display="menu"></p-columnFilter>
          <p-sortIcon field="client_code"></p-sortIcon>
        </div>
      </th>
      <th pSortableColumn="first_name">
        <div class="col">
          Имя
          <p-columnFilter type="text" field="first_name" display="menu"></p-columnFilter>
          <p-sortIcon field="first_name"></p-sortIcon>
        </div>
      </th>
      <th pSortableColumn="last_name">
        <div class="col">
          Фамилия
          <p-columnFilter type="text" field="last_name" display="menu"></p-columnFilter>
          <p-sortIcon field="last_name"></p-sortIcon>
        </div>
      </th>
      <th pSortableColumn="client_city">
        <div class="col">
          Город
          <p-columnFilter type="text" field="client_city" display="menu"></p-columnFilter>
          <p-sortIcon field="client_city"></p-sortIcon>
        </div>
      </th>
      <th pSortableColumn="phone">
        <div class="col">
          Телефон
          <p-columnFilter type="text" field="phone" display="menu"></p-columnFilter>
          <p-sortIcon field="phone"></p-sortIcon>
        </div>
      </th>
      <th pSortableColumn="email">
        <div class="col">
          Email
          <p-columnFilter type="text" field="email" display="menu"></p-columnFilter>
          <p-sortIcon field="email"></p-sortIcon>
        </div>
      </th>
      <th pSortableColumn="created_on">
        <div class="col">
          Зарегистрирован
          <p-sortIcon field="created_on"></p-sortIcon>
        </div>
      </th>
      <th pSortableColumn="last_login">
        <div class="col">
          Вход
          <p-sortIcon field="last_login"></p-sortIcon>
        </div>
      </th>
      <th>
        <div class="col">
          Ожидается
        </div>
      </th>
      <th>
        <div class="col">
          Удалено
        </div>
      </th>
      <th>&nbsp;</th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-client>
    <tr>
      <td class="nobr">{{client.login}}</td>
      <td class="nobr">{{client.client_code}}</td>
      <td class="nobr">{{client.first_name}}</td>
      <td class="nobr">{{client.last_name}}</td>
      <td class="nobr">{{client.client_city }}</td>
      <td class="nobr">{{client.phone}}</td>
      <td class="nobr">{{client.email}}</td>
      <td class="nobr">{{client.created_on | date: 'dd.MM.yyyy'}}</td>
      <td class="nobr">{{client.last_login | date: 'dd.MM.yyyy'}}</td>
      <td>
        <div class="col">{{client.waiting_pkg_cnt}}</div>
      </td>
      <td>
        <div class="col">{{client.deleted_pkg_cnt}}</div>
      </td>

      <td>
        <div class="col nobr">
          <p-button icon="pi pi-trash" styleClass="p-button-text" (click)="removeClient(client.id)"
            pTooltip="Удалить клиента">
          </p-button>
          <p-button icon="pi pi-user-edit" styleClass="p-button-text" (click)="editClient(client)" pTooltip="Редактировать клиента">
          </p-button>
          <p-button icon="pi pi-unlock" styleClass="p-button-text" (click)="resetPasswd(client)" pTooltip="Сбросить пароль"/>
        </div>
      </td>
    </tr>
  </ng-template>
  <ng-template pTemplate="paginatorleft">
    <p-button 
      type="button" 
      icon="pi pi-eject" 
      styleClass="p-button-text" 
      pTooltip="Экспортировать список клиентов"
      (click)="exportClientsList()"
    ></p-button>
  </ng-template>
  <ng-template pTemplate="paginatorright">
    <!-- <p-button type="button" icon="pi pi-plus" styleClass="p-button-text"  (click)="createClient()"
      pTooltip="Создать нового клиента">
    </p-button> -->
    <div>&nbsp;</div>
  </ng-template>
</p-table>

@if(!clientList) {
<div [ngStyle]="{'text-align': 'center'}">
  <p-progressSpinner styleClass="w-16 h-16" strokeWidth="6" fill="var(--surface-ground)" animationDuration="4s"></p-progressSpinner>
</div>
}

<app-client-form [(visible)]="clientDialogVisible" [clientData]="currentClient" (dataChanged)="dataChanged($event)" (onHide)="hideClientDialog()"/>
<app-reset-passwd [(visible)]="resetPasswdDlgVisible" [clientData]="currentClient" (onHide)="hideClientDialog()" />